import { inject, Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { ServiceType } from 'src/app/contracts';
import { Logs } from 'src/app/core/contracts';
import { styledLog } from 'src/app/core/helpers/logger';

@Injectable()
export class Back {
  private router = inject(Router);

  async canBackWithNavigation(currentUrl: string, nextUrl?: string): Promise<{ exit: boolean; canGoBack?: boolean; redirectTo?: UrlTree }> {
    if (Logs.ENABLE_BACK_NAVIGATION_LOGS) {
      styledLog({ msg: `<-- canBackWithNavigation currentUrl: ${currentUrl}` }, { 'background-color': '#FFDAC1', color: 'black' });
      styledLog({ msg: `<-- canBackWithNavigation nextUrl: ${nextUrl}` }, { 'background-color': '#D3FFC6', color: 'black' });
    }

    // TODO:revamp update to match the new routes
    if (currentUrl.startsWith('/hourly/details') && nextUrl.startsWith('/hourly/new/summary')) {
      const url = this.router.createUrlTree(['/tabs/contracts', { service: ServiceType.Hourly }]);
      return { canGoBack: false, exit: false, redirectTo: url };
    }

    if (currentUrl.startsWith('/monthly/request/details') && nextUrl.startsWith('/monthly/request/summary')) {
      const url = this.router.createUrlTree(['/tabs/contracts', { service: ServiceType.Monthly }]);
      return { canGoBack: false, exit: false, redirectTo: url };
    }

    return Promise.resolve({ canGoBack: true, exit: false });
  }
  async canBackWithPhysicalButton(currentUrl: string, nextUrl?: string): Promise<{ exit: boolean; canGoBack?: boolean; redirectTo?: UrlTree }> {
    if (Logs.ENABLE_BACK_NAVIGATION_LOGS) {
      styledLog({ msg: `<-- canBackWithPhysicalButton currentUrl: ${currentUrl}` }, { 'background-color': '#FFDAC1', color: 'black' });
      styledLog({ msg: `<-- canBackWithPhysicalButton nextUrl: ${nextUrl}` }, { 'background-color': '#D3FFC6', color: 'black' });
    }

    // TODO:revamp update to match the new routes
    if (currentUrl.startsWith('/hourly/details') && nextUrl.startsWith('/hourly/new/summary')) {
      const url = this.router.createUrlTree(['/tabs/contracts', { service: ServiceType.Hourly }]);
      return { canGoBack: false, exit: false, redirectTo: url };
    }

    if (currentUrl.startsWith('/monthly/request/details') && nextUrl.startsWith('/monthly/request/summary')) {
      const url = this.router.createUrlTree(['/tabs/contracts', { service: ServiceType.Monthly }]);
      return { canGoBack: false, exit: false, redirectTo: url };
    }

    if (currentUrl.includes('/tabs/contracts')) {
      const url = this.router.createUrlTree(['/tabs/home']);
      return { canGoBack: false, exit: false, redirectTo: url };
    }

    if (currentUrl === '/' || currentUrl === '/tabs/home') {
      return { exit: true };
    }

    return Promise.resolve({ canGoBack: true, exit: false });
  }
}
